// Tinker + LPO variant media “stick” fix
// Uses Tinker’s own variant update payload to select the correct media by mediaId.

(function () {
  function selectMediaById(mediaId) {
    if (!mediaId) return false;

    // Tinker/OS2 galleries usually render items with data-media-id like: "SectionId-MediaId"
    const all = document.querySelectorAll('[data-media-id]');
    if (!all.length) return false;

    let target = null;
    all.forEach((el) => {
      const id = el.getAttribute('data-media-id') || '';
      if (id.endsWith(String(mediaId))) target = el;
    });

    if (!target) return false;

    // Hide all
    all.forEach((el) => {
      el.style.display = 'none';
      el.classList.remove('is-active');
      el.setAttribute('aria-hidden', 'true');
    });

    // Show target
    target.style.display = '';
    target.classList.add('is-active');
    target.setAttribute('aria-hidden', 'false');

    return true;
  }

  function extractMediaIdFromTinkerPayload(payload) {
    // Payload shapes vary; we try several common paths safely:
    return (
      payload?.variant?.featured_media?.id ||
      payload?.variant?.featured_media_id ||
      payload?.variant?.featuredMedia?.id ||
      payload?.product?.selected_or_first_available_variant?.featured_media?.id ||
      null
    );
  }

  // This is what variant-picker.js will call
  window.SC_forceVariantMediaSwapFromTinker = function (payload) {
    const mediaId = extractMediaIdFromTinkerPayload(payload);
    if (!mediaId) return;

    // Apply multiple times to win races on heavy templates like the 112 page
    selectMediaById(mediaId);
    setTimeout(() => selectMediaById(mediaId), 80);
    setTimeout(() => selectMediaById(mediaId), 250);
    setTimeout(() => selectMediaById(mediaId), 900);
  };
})();